import { render, staticRenderFns } from "./StopIcon.vue?vue&type=template&id=2e09b930&scoped=true"
import script from "./StopIcon.vue?vue&type=script&lang=js"
export * from "./StopIcon.vue?vue&type=script&lang=js"
import style0 from "./StopIcon.vue?vue&type=style&index=0&id=2e09b930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e09b930",
  null
  
)

export default component.exports